import { useStore } from '@/utils/vue-api';
import { computed } from 'vue';

export function useModuleAttrs() {
	const isCustomM = module => {
		const { type } = module;
		return type === 1;
	};
	const isDisplayM = module => {
		const { type } = module;
		return type === 2;
	};

	const getModuleId = module => {
		const { moduleId } = module;
		if (isCustomM(module)) return 'custom';
		if (isDisplayM(module)) return 'widget_shell';
		return moduleId;
	};

	const getModuleProps = module => {
		if (isCustomM(module) || isDisplayM(module)) {
			return {
				moduleData: module
			};
		}
		return {};
	};

	const createModuleKey = () => {
		return Date.now() + Math.floor(Math.random() * 1000000);
	};
	const getModuleKey = module => {
		const { _key, moduleId } = module;
		return _key || moduleId;
	};

	const store = useStore();
	const getSystemModules = computed(() => store.getters.getIrTemplateFlattenModules);
	const getGlobalModules = computed(() => store.getters.getIrGlobalModules);
	const searchModule = moduleId => {
		const globalModules = getGlobalModules.value;
		const systemModules = getSystemModules.value;
		const allModules = [...systemModules, ...globalModules];
		const activeModule = allModules.find(m => m.moduleId === moduleId);
		return activeModule || null;
	};
	const searchModuleIdWithParams = moduleId => {
		const hasNumber = /\d/.test(moduleId);
		if (!hasNumber) return moduleId;
		const activeModule = searchModule(moduleId);
		return getModuleId(activeModule || {});
	};

	return {
		isCustomM,
		isDisplayM,

		getModuleId,
		getModuleProps,
		getModuleKey,
		createModuleKey,
		searchModule,
		searchModuleIdWithParams
	};
}
